import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
interface PricingOfferProps {
  cartLink: string;
}
export const PricingOffer: React.FC<PricingOfferProps> = ({
  cartLink
}) => {
  return <section className="py-20 md:py-32 px-4 bg-gradient-to-b from-brand-rose to-brand-blush" data-id="element-146">
      <div className="max-w-5xl mx-auto" data-id="element-147">
        <div className="text-center mb-12" data-id="element-148">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-149">
            Haz Click Debajo Para Empezar Ahora:
          </h2>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row max-w-4xl mx-auto border border-brand-gold/20" data-id="element-150">
          {/* Left: Mockup & Badge */}
          <div className="w-full md:w-5/12 bg-brand-cream p-8 md:p-12 flex items-center justify-center relative" data-id="element-151">
            <div className="absolute top-6 right-6 w-24 h-24 bg-brand-gold text-white rounded-full flex flex-col items-center justify-center shadow-lg transform rotate-12 z-10 border-4 border-white" data-id="element-152">
              <span className="text-2xl font-bold leading-none" data-id="element-153">-50%</span>
              <span className="text-sm font-bold" data-id="element-154">OFF</span>
            </div>

            <div className="relative w-full max-w-[280px] aspect-[3/4] shadow-2xl rounded-r-2xl rounded-l-sm overflow-hidden border-l-8 border-brand-wine/80" data-id="element-155">
              <img src="https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Mockup de la guía" className="w-full h-full object-cover" data-id="element-156" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6" data-id="element-157">
                <span className="text-white font-serif font-bold text-xl leading-tight" data-id="element-158">
                  La Guía Definitiva
                </span>
              </div>
            </div>
          </div>

          {/* Right: Pricing & CTA */}
          <div className="w-full md:w-7/12 p-8 md:p-12 flex flex-col justify-center" data-id="element-159">
            <div className="inline-block bg-emerald-100 text-emerald-800 px-4 py-1.5 rounded-full text-sm font-bold mb-6 w-fit" data-id="element-160">
              🎁 Oferta -50% OFF sólo 20 cupos
            </div>

            <div className="mb-8" data-id="element-161">
              <div className="text-gray-500 font-medium text-lg mb-2" data-id="element-162">
                Antes: <PriceDisplay basePriceARS={40000} strikeThrough data-id="element-163" />
              </div>
              <div className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-4" data-id="element-164">
                <span className="text-xl font-bold text-brand-wine" data-id="element-165">
                  PRECIO DE HOY:
                </span>
                <PriceDisplay basePriceARS={25990} className="text-4xl md:text-5xl font-serif font-bold text-brand-charcoal" data-id="element-166" />
              </div>
            </div>

            <CTAButton href={cartLink} fullWidth className="mb-6 py-5 text-xl" data-id="element-167">
              Obtener Acceso Instantáneo
            </CTAButton>

            <div className="text-center font-medium text-brand-wine mb-8 animate-pulse" data-id="element-168">
              ⚡ Últimos 3 Cupos en Oferta!
            </div>

            {/* Trust Elements */}
            <div className="border-t border-gray-100 pt-6 mt-auto" data-id="element-169">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-gray-500" data-id="element-170">
                <div className="flex items-center gap-2" data-id="element-171">
                  <Lock className="w-5 h-5 text-gray-400" data-id="element-172" />
                  <span data-id="element-173">Pago Seguro</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-174">
                  <ShieldCheck className="w-5 h-5 text-gray-400" data-id="element-175" />
                  <span data-id="element-176">Garantía 60 Días</span>
                </div>
              </div>

              <div className="flex items-center justify-center gap-4 mt-4 text-gray-400" data-id="element-177">
                <span className="font-bold border px-2 py-1 rounded text-xs" data-id="element-178">
                  VISA
                </span>
                <span className="font-bold border px-2 py-1 rounded text-xs" data-id="element-179">
                  MASTERCARD
                </span>
                <span className="font-bold border px-2 py-1 rounded text-xs" data-id="element-180">
                  MERCADO PAGO
                </span>
              </div>

              <p className="text-center text-xs mt-4" data-id="element-181">
                Pago único. SIN mensualidades.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};